module.exports = __webpack_public_path__ + "static/media/partner11.e727b249.jpg";